var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "confirm-line-haul-connection"
  }, [_c('div', {
    staticClass: "animated fadeInDown"
  }, [_c('fieldset', [_c('div', {
    staticClass: "card-body1"
  }, [_c('legend', [_vm._v("Create Run Sheet")]), _vm._v(" "), _c('b-card', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Select SR")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-user'></i>",
      "right": _vm.srLoader
    }
  }, [_c('b-input-group', [_c('basic-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "options": _vm.srList,
      "selected-option": _vm.srItemObj,
      "name": "SR",
      "placeholder": "Select SR"
    },
    on: {
      "select": _vm.selectSR
    },
    model: {
      value: (_vm.srId),
      callback: function($$v) {
        _vm.srId = $$v
      },
      expression: "srId"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('SR')),
      expression: "errors.has('SR')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('SR')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('b-form-fieldset', [_c('b-input-group', [_c('b-button', {
    staticClass: "btn btn-success mr-2",
    attrs: {
      "type": "button",
      "disabled": _vm.startTripFlag == false
    },
    on: {
      "click": function($event) {
        return _vm.startTrip()
      }
    }
  }, [_vm._v(_vm._s(_vm.tripTitle))]), _vm._v(" "), _c('b-button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "disabled": _vm.srId == false
    },
    on: {
      "click": function($event) {
        return _vm.resetTrip()
      }
    }
  }, [_vm._v("Reset")])], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.startTripFlag && _vm.vehicleTypeFlag && _vm.tripTitle == 'Start Trip'),
      expression: "startTripFlag && vehicleTypeFlag && tripTitle=='Start Trip'"
    }],
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_vm._v("Select Vehicle Type"), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-input-group', [_c('b-button', {
    staticClass: "btn btn-primary1 mr-2",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.loadVehicleDetails('bike')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-motorcycle"
  }), _vm._v(" Bike")]), _vm._v(" "), _c('b-button', {
    staticClass: "btn btn-primary1",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.loadVehicleDetails('vehicle')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-truck"
  }), _vm._v(" Vehicle")])], 1)], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.startTripFlag && _vm.vehicleTypeFlag && _vm.vehicleType),
      expression: "startTripFlag && vehicleTypeFlag && vehicleType"
    }],
    staticClass: "row mt-2"
  }, [((_vm.vehicleType == 'bike' && _vm.srVehicleList.length == 0) || _vm.isVehicleReplaced == true) ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Vehicle No")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-car'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vehicleNo),
      expression: "vehicleNo"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('weight')
    },
    attrs: {
      "type": "text",
      "placeholder": "Vehicle No",
      "name": "vehicleNo"
    },
    domProps: {
      "value": (_vm.vehicleNo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.vehicleNo = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errVehicleNo),
      expression: "errVehicleNo"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errVehicleNo))]), _vm._v(" "), _c('label', {
    staticStyle: {
      "font-size": "11px",
      "color": "#7d7878",
      "font-weight": "700"
    }
  }, [_vm._v("(eg: MH 12 HA 5678 / DL 01 L HA 5678)")])], 1)], 1) : _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Vehicle No")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-car'></i>"
    }
  }, [_c('basic-select', {
    class: {
      'form-control': true
    },
    attrs: {
      "options": _vm.srVehicleList,
      "selected-option": _vm.vehicleNoItemObj,
      "name": "vehicleNo",
      "placeholder": "Select Vehicle No"
    },
    on: {
      "select": _vm.selectVehicleNo
    },
    model: {
      value: (_vm.vehicleNo),
      callback: function($$v) {
        _vm.vehicleNo = $$v
      },
      expression: "vehicleNo"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Vehicle Open KM")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-road'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vehicleOpenKM),
      expression: "vehicleOpenKM"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('weight')
    },
    attrs: {
      "type": "text",
      "placeholder": "Vehicle Open KM",
      "name": "vehicleOpenKM"
    },
    domProps: {
      "value": (_vm.vehicleOpenKM)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.vehicleOpenKM = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errVehicleKm),
      expression: "errVehicleKm"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errVehicleKm))])], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.vehicleType == 'bike' && _vm.srVehicleList.length > 0),
      expression: "vehicleType=='bike' && srVehicleList.length>0"
    }],
    staticClass: "col-md-6"
  }, [_c('b-form-checkbox', {
    attrs: {
      "value": "1",
      "unchecked-value": "0"
    },
    on: {
      "change": function($event) {
        return _vm.isVehicleReplaceCheck($event)
      }
    },
    model: {
      value: (_vm.isVehicleReplacedCheck),
      callback: function($$v) {
        _vm.isVehicleReplacedCheck = $$v
      },
      expression: "isVehicleReplacedCheck"
    }
  }, [_vm._v("Is Vehicle Replaced?")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('b-button', {
    staticClass: "btn btn-success mr-2",
    attrs: {
      "type": "button",
      "disabled": _vm.vehicleNo == '' || _vm.vehicleOpenKM == ''
    },
    on: {
      "click": function($event) {
        return _vm.startAllocation(true)
      }
    }
  }, [_vm._v("Start Allocation")])], 1)]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.allocation()
      }
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.startAllocationFlag),
      expression: "startAllocationFlag"
    }],
    staticClass: "row mt-3"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('legend', [_vm._v("Allocation")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 mt-3"
  }, [_c('label', [_vm._v("Delivery Option")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-cog'></i>"
    }
  }, [_c('basic-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    ref: "deliveryOption",
    class: {
      'form-control': true
    },
    attrs: {
      "id": "deliveryOption",
      "options": _vm.deliveryOptionList,
      "selected-option": _vm.deliveryOptionItemObj,
      "name": "deliveryOption",
      "placeholder": "Select Delivery Option"
    },
    on: {
      "select": _vm.selectDeliveryOption
    },
    model: {
      value: (_vm.deliveryOption),
      callback: function($$v) {
        _vm.deliveryOption = $$v
      },
      expression: "deliveryOption"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('deliveryOption')),
      expression: "errors.has('deliveryOption')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('deliveryOption')))])], 1), _vm._v(" "), (_vm.deliveryOption != 'Delivery') ? _c('div', {
    staticClass: "col-md-6 mt-3"
  }, [_c('label', [_vm._v("Select Client")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-users'></i>"
    }
  }, [_c('basic-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "options": _vm.clientOptionList,
      "selected-option": _vm.clientOptionItemObj,
      "name": "clientOption",
      "placeholder": "Select Client"
    },
    on: {
      "select": _vm.selectClient
    },
    model: {
      value: (_vm.clientOption),
      callback: function($$v) {
        _vm.clientOption = $$v
      },
      expression: "clientOption"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('clientOption')),
      expression: "errors.has('clientOption')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('clientOption')))])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row mt-2"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_vm._v("Hub Name : ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9 bagin-dtl"
  }, [_vm._v(_vm._s(_vm.srHubName))])]), _vm._v(" "), _c('div', {
    staticClass: "row mt-2"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_vm._v("SR Name : ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9 bagin-dtl"
  }, [_vm._v(_vm._s(_vm.srName))])]), _vm._v(" "), _c('div', {
    staticClass: "row mt-2"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Shipment No")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-ship'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shipmentNo),
      expression: "shipmentNo"
    }],
    ref: "shipmentNo",
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter / Scan Shipment No",
      "autocomplete": "off",
      "name": "shipmentNo"
    },
    domProps: {
      "value": (_vm.shipmentNo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.shipmentNo = $event.target.value
      }
    }
  })])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 mr-2"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(" ")]), _vm._v(" "), _c('b-input-group', [_c('b-button', {
    staticClass: "btn btn-success mr-2",
    attrs: {
      "type": "submit",
      "disabled": !_vm.flagAllocation
    }
  }, [_vm._v("Allocation")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.flagShowPreviousShipment),
      expression: "flagShowPreviousShipment"
    }],
    staticClass: "col-md-2"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(" ")]), _vm._v(" "), _c('b-input-group', [_c('b-button', {
    staticClass: "btn btn-success mr-2",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.ShowShipments()
      }
    }
  }, [_vm._v("Show Shipments")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoadingAlc),
      expression: "isLoadingAlc"
    }],
    staticClass: "col-md-2"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(" ")]), _vm._v(" "), _c('vue-element-loading', {
    staticStyle: {
      "margin-top": "48px"
    },
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoadingAlc,
      "size": "30"
    },
    on: {
      "update:active": function($event) {
        _vm.isLoadingAlc = $event
      }
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v("Select Web/Mobile")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-cog'></i>"
    }
  }, [_c('basic-select', {
    class: {
      'form-control': true
    },
    attrs: {
      "options": _vm.fromList,
      "selected-option": _vm.fromItemObj,
      "name": "from",
      "placeholder": "Select From"
    },
    on: {
      "select": _vm.selectFrom
    },
    model: {
      value: (_vm.fromId),
      callback: function($$v) {
        _vm.fromId = $$v
      },
      expression: "fromId"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 mt-2"
  }, [_c('b-button', {
    staticClass: "btn btn-success mr-2",
    attrs: {
      "type": "button",
      "disabled": _vm.isAllocation == false
    },
    on: {
      "click": function($event) {
        return _vm.confirmTrip()
      }
    }
  }, [_vm._v("Confirm Trip")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row mt-2"
  }), _vm._v(" "), _c('div', {
    staticClass: "row mt-2"
  }, [_c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_c('b-alert', {
    attrs: {
      "show": _vm.dismissCountDown,
      "dismissible": "",
      "fade": "",
      "variant": "danger"
    },
    on: {
      "dismiss-count-down": _vm.countDownChanged
    }
  }, [_vm._v("\n                          " + _vm._s(_vm.allocationErrorMsg) + "\n                        ")]), _vm._v(" "), _c('b-alert', {
    attrs: {
      "show": _vm.dismissCountDownSuccess,
      "dismissible": "",
      "fade": "",
      "variant": "success"
    },
    on: {
      "dismiss-count-down": _vm.countDownChangedSuccess
    }
  }, [_vm._v("\n                          " + _vm._s(_vm.allocationSuccessMsg) + "\n                        ")])], 1)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('b-tabs', {
    staticStyle: {
      "border": "1px solid #cecece"
    },
    attrs: {
      "content-class": "mt-3"
    }
  }, [_c('b-tab', {
    attrs: {
      "title": "Allocated Shipment List",
      "selected": true
    },
    on: {
      "click": function($event) {
        return _vm.loadSrShipmentDetails()
      }
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoadingASL
    },
    on: {
      "update:active": function($event) {
        _vm.isLoadingASL = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "max-height": "400px",
      "height": "auto",
      "overflow-y": "auto"
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('span', {
    staticStyle: {
      "cursor": "pointer",
      "font-size": "18px",
      "float": "left"
    },
    on: {
      "click": function($event) {
        return _vm.loadSrShipmentDetails()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh",
    attrs: {
      "title": "Reload this Allocated Shipment List"
    }
  })]), _vm._v("  \n                            "), _c('span', {
    staticClass: "bagin-dtl1"
  }, [_vm._v("Total Shipments : " + _vm._s(_vm.srShipmentList.length))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "cursor": "pointer",
      "font-size": "18px",
      "float": "right",
      "margin-bottom": "5px"
    }
  }, [_c('b-input-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchByShippingId),
      expression: "searchByShippingId"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('searchByShippingId')
    },
    attrs: {
      "type": "text",
      "placeholder": "Search by shippingid",
      "name": "searchByShippingId"
    },
    domProps: {
      "value": (_vm.searchByShippingId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchByShippingId = $event.target.value
      }
    }
  }), _vm._v(" "), _c('b-input-group-append', [_c('b-button', {
    staticStyle: {
      "border-radius": "0px",
      "background-color": "#f0f3f5",
      "border": "1px solid #c2cfd6"
    },
    on: {
      "click": function($event) {
        return _vm.loadSrShipmentDetails()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }, [_vm._v(" Search ")])])], 1)], 1)], 1), _vm._v("  \n\n                            "), _c('table', {
    staticClass: "b-table table table-bordered"
  }, [_c('thead', {
    staticClass: "thead-default"
  }, [_c('tr', [_c('th', [_vm._v("Shipping ID")]), _vm._v(" "), _c('th', [_vm._v("Ship Pincode")]), _vm._v(" "), _c('th', [_vm._v("Customer Address")]), _vm._v(" "), _c('th', [_vm._v("Service Type")]), _vm._v(" "), _c('th', [_vm._v("Net Payment")]), _vm._v(" "), _c('th', [_vm._v("Shipment Type")]), _vm._v(" "), _c('th', [_vm._v(" ")])])]), _vm._v(" "), _c('tbody', [(_vm.srShipmentList.length > 0) ? _vm._l((_vm.srShipmentList), function(row) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(row.ShippingID))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.ShipPincode))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.CustomerAddress))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.ServiceType))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.NetPayment))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.shipmenttype))]), _vm._v(" "), _c('td', [_c('i', {
      staticClass: "fa fa-times-circle",
      staticStyle: {
        "cursor": "pointer",
        "font-size": "18px"
      },
      on: {
        "click": function($event) {
          return _vm.removeShipment(row.ShippingID)
        }
      }
    })])])
  }) : [_c('tr', [_c('td', {
    attrs: {
      "colspan": "7",
      "align": "center"
    }
  }, [_vm._v("No record found")])])]], 2)])])])], 1), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "Pending Shipment List",
      "selected": true
    },
    on: {
      "click": function($event) {
        return _vm.loadPendingShipmentList()
      }
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoadingPSL
    },
    on: {
      "update:active": function($event) {
        _vm.isLoadingPSL = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "max-height": "400px",
      "height": "auto",
      "overflow-y": "auto"
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('span', {
    staticStyle: {
      "cursor": "pointer",
      "font-size": "18px"
    },
    on: {
      "click": function($event) {
        return _vm.loadPendingShipmentList()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh",
    attrs: {
      "title": "Reload this pending shipment list"
    }
  })]), _vm._v("  \n                            "), _c('span', {
    staticStyle: {
      "cursor": "pointer",
      "font-size": "18px"
    },
    on: {
      "click": function($event) {
        return _vm.fullScreenPendingShipmentList()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrows-alt",
    attrs: {
      "title": "View full screen"
    }
  })]), _vm._v(" "), _c('span', {
    staticStyle: {
      "cursor": "pointer",
      "font-size": "18px",
      "float": "right",
      "margin-bottom": "5px"
    }
  }, [_c('b-input-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.PsearchByShippingId),
      expression: "PsearchByShippingId"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('PsearchByShippingId')
    },
    attrs: {
      "type": "text",
      "placeholder": "Search by shippingid",
      "name": "PsearchByShippingId"
    },
    domProps: {
      "value": (_vm.PsearchByShippingId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.PsearchByShippingId = $event.target.value
      }
    }
  }), _vm._v(" "), _c('b-input-group-append', [_c('b-button', {
    staticStyle: {
      "border-radius": "0px",
      "background-color": "#f0f3f5",
      "border": "1px solid #c2cfd6"
    },
    on: {
      "click": function($event) {
        return _vm.loadPendingShipmentList()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }, [_vm._v(" Search ")])])], 1)], 1)], 1), _vm._v("  \n                            "), _c('table', {
    staticClass: "b-table table table-bordered"
  }, [_c('thead', {
    staticClass: "thead-default"
  }, [_c('tr', [_c('th', [_vm._v("Pending Days")]), _vm._v(" "), _c('th', [_vm._v("Pending At Dest")]), _vm._v(" "), _c('th', [_vm._v("Shipping ID")]), _vm._v(" "), _c('th', [_vm._v("RP ShippingId")]), _vm._v(" "), _c('th', [_vm._v("Total Attempts")]), _vm._v(" "), _c('th', [_vm._v("Last Status")]), _vm._v(" "), _c('th', [_vm._v("Shipping Date")]), _vm._v(" "), _c('th', [_vm._v("Net Payment")]), _vm._v(" "), _c('th', [_vm._v("Order Type")]), _vm._v(" "), _c('th', [_vm._v("IsSame DayDelv.")]), _vm._v(" "), _c('th', [_vm._v("EDD")]), _vm._v(" "), _c('th', [_vm._v("Address Type")])])]), _vm._v(" "), _c('tbody', [(_vm.pendingShipmentList.length > 0) ? _vm._l((_vm.pendingShipmentList), function(row) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(row.PendingDays))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.PendingDays))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.ShippingID))]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.TotalAttemptCount))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.ShipmentStatus))]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.CollectibleAmount))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.OrderType))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.isSameDayDelivery(row.IsSameDayDelivery)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.EDD))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.AddressType))])])
  }) : [_c('tr', [_c('td', {
    attrs: {
      "colspan": "12",
      "align": "center"
    }
  }, [_vm._v("No record found")])])]], 2)]), _vm._v(" "), (_vm.totalPendingShipment > 20) ? _c('paginate', {
    attrs: {
      "page-count": _vm.pageCount,
      "page-range": 2,
      "margin-pages": 2,
      "click-handler": _vm.getPaginationData,
      "prev-text": '<<',
      "next-text": '>>',
      "container-class": 'pagination'
    }
  }) : _vm._e()], 1)])], 1)], 1)], 1)])])])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "lg",
      "title": "Confirmation"
    },
    on: {
      "click": function($event) {
        _vm.closeCloseTripModel = false
      }
    },
    model: {
      value: (_vm.closeTripModel),
      callback: function($$v) {
        _vm.closeTripModel = $$v
      },
      expression: "closeTripModel"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Trip Details")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeCloseTripModel
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_vm._v("SR Name : "), _c('span', {
    staticClass: "bagin-dtl"
  }, [_vm._v(_vm._s(_vm.srName))])])]), _vm._v(" "), _c('div', {
    staticClass: "row mt-2"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v("Open KM")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "350px"
    },
    attrs: {
      "src": _vm.openKmImg,
      "alt": ""
    },
    on: {
      "error": function($event) {
        return _vm.loadOpenImageError(_vm.openKmImg)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 mt-3"
  }, [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-road'></i>"
    }
  }, [_c('b-input-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.openKm),
      expression: "openKm"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter Open KM",
      "name": "openKm",
      "disabled": _vm.openKm
    },
    domProps: {
      "value": (_vm.openKm)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.openKm = $event.target.value
      }
    }
  })])], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v("Close KM")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "350px"
    },
    attrs: {
      "src": _vm.closeKmImg,
      "alt": ""
    },
    on: {
      "error": function($event) {
        return _vm.loadCloseImageError(_vm.closeKmImg)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 mt-3"
  }, [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-road'></i>"
    }
  }, [_c('b-input-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.closeKm),
      expression: "closeKm"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter Close KM",
      "name": "closeKm"
    },
    domProps: {
      "value": (_vm.closeKm)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.closeKm = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errorCloseKM),
      expression: "errorCloseKM"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errorCloseKM))])], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "disabled": _vm.closeKm == ''
    },
    on: {
      "click": function($event) {
        return _vm.verifyTrip()
      }
    }
  }, [_vm._v("Verify/Modify")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        return _vm.closeCloseTripModel()
      }
    }
  }, [_vm._v("Cancel")])])])])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "vlg",
      "title": "Pending Shipment List"
    },
    model: {
      value: (_vm.pendingShipModel),
      callback: function($$v) {
        _vm.pendingShipModel = $$v
      },
      expression: "pendingShipModel"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Pending Shipment List")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closePendingShipModel
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoadingPSLModel
    },
    on: {
      "update:active": function($event) {
        _vm.isLoadingPSLModel = $event
      }
    }
  }), _vm._v(" "), _c('table', {
    staticClass: "b-table table table-bordered",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', {
    staticClass: "thead-default"
  }, [_c('tr', [_c('th', [_vm._v("Pending Days")]), _vm._v(" "), _c('th', [_vm._v("Pending At Dest")]), _vm._v(" "), _c('th', [_vm._v("Shipping ID")]), _vm._v(" "), _c('th', [_vm._v("RP ShippingId")]), _vm._v(" "), _c('th', [_vm._v("Total Attempts")]), _vm._v(" "), _c('th', [_vm._v("Last Status")]), _vm._v(" "), _c('th', [_vm._v("Shipping Date")]), _vm._v(" "), _c('th', [_vm._v("Net Payment")]), _vm._v(" "), _c('th', [_vm._v("Order Type")]), _vm._v(" "), _c('th', [_vm._v("IsSame DayDelv.")]), _vm._v(" "), _c('th', [_vm._v("EDD")]), _vm._v(" "), _c('th', [_vm._v("Address Type")])])]), _vm._v(" "), _c('tbody', [(_vm.pendingShipmentListMdl.length > 0) ? _vm._l((_vm.pendingShipmentListMdl), function(row) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(row.PendingDays))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.PendingDays))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.ShippingID))]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.TotalAttemptCount))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.ShipmentStatus))]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.CollectibleAmount))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.OrderType))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.isSameDayDelivery(row.IsSameDayDelivery)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.EDD))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.AddressType))])])
  }) : [_c('tr', [_c('td', {
    attrs: {
      "colspan": "12",
      "align": "center"
    }
  }, [_vm._v("No record found")])])]], 2)]), _vm._v(" "), (_vm.totalPendingShipmentMdl > 20) ? _c('paginate', {
    attrs: {
      "page-count": _vm.pageCountMdl,
      "page-range": 2,
      "margin-pages": 2,
      "click-handler": _vm.getPaginationDataModel,
      "prev-text": '<<',
      "next-text": '>>',
      "container-class": 'pagination'
    }
  }) : _vm._e()], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        return _vm.closePendingShipModel()
      }
    }
  }, [_vm._v("Close")])])])])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "lg",
      "title": "Confirmation"
    },
    on: {
      "click": function($event) {
        _vm.closeShipmentModel = false
      }
    },
    model: {
      value: (_vm.showShipmentModel),
      callback: function($$v) {
        _vm.showShipmentModel = $$v
      },
      expression: "showShipmentModel"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Pending Shipment List")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeShipmentModel
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('table', {
    staticClass: "b-table table table-bordered",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', {
    staticClass: "thead-default"
  }, [_c('tr', [_c('th', [_vm._v("ShippingID")]), _vm._v(" "), _c('th', [_vm._v("Status")]), _vm._v(" "), _c('th', [_vm._v("Shipment Status Name")]), _vm._v(" "), _c('th', [_vm._v("Created Date")])])]), _vm._v(" "), _c('tbody', [(_vm.showShipmentList.length > 0) ? _vm._l((_vm.showShipmentList), function(row) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(row.ShippingID))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.Status))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.ShipmentStatusName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("moment")(row.CreatedDate)))])])
  }) : [_c('tr', [_c('td', {
    attrs: {
      "colspan": "4",
      "align": "center"
    }
  }, [_vm._v("No record found")])])]], 2)])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm",
    staticStyle: {
      "float": "right"
    }
  }, [_c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        return _vm.closeShipmentModel()
      }
    }
  }, [_vm._v("close")])])])])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "vlg",
      "title": "RVP Allocated Shipment",
      "no-close-on-backdrop": "",
      "scrollable": ""
    },
    on: {
      "hidden": _vm.closeRvpShipmentsModel
    },
    model: {
      value: (_vm.rvpShipmentsModel),
      callback: function($$v) {
        _vm.rvpShipmentsModel = $$v
      },
      expression: "rvpShipmentsModel"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("RVP Allocated Shipment")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeRvpShipmentsModel
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoadingRvpPickup
    },
    on: {
      "update:active": function($event) {
        _vm.isLoadingRvpPickup = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('fieldset', [_c('legend', [_vm._v("List")]), _vm._v(" "), _c('b-card', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Pickups")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-truck'></i>"
    }
  }, [_c('basic-select', {
    attrs: {
      "options": _vm.pickupData,
      "selected-option": _vm.pickupItem,
      "name": "fltpickup",
      "placeholder": "Select Pickup"
    },
    on: {
      "select": _vm.selectPickups
    },
    model: {
      value: (_vm.fltpickup),
      callback: function($$v) {
        _vm.fltpickup = $$v
      },
      expression: "fltpickup"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("From / To Date")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-calendar-o'></i>"
    }
  }, [_c('date-picker', {
    attrs: {
      "range": "",
      "lang": "en",
      "name": "fromToDate",
      "format": "DD-MM-YYYY"
    },
    model: {
      value: (_vm.fromToDate),
      callback: function($$v) {
        _vm.fromToDate = $$v
      },
      expression: "fromToDate"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "margin-top": "25px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.showPendingPickups
    }
  }, [_vm._v("Show Pending Pickups")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Select Web/Mobile")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-cog'></i>"
    }
  }, [_c('basic-select', {
    class: {
      'form-control': true
    },
    attrs: {
      "options": _vm.fromList,
      "selected-option": _vm.fromItemObj,
      "name": "from",
      "isDisabled": "",
      "placeholder": "Select From"
    },
    on: {
      "select": _vm.selectFrom
    },
    model: {
      value: (_vm.fromId),
      callback: function($$v) {
        _vm.fromId = $$v
      },
      expression: "fromId"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('button', {
    staticClass: "btn btn-success",
    staticStyle: {
      "margin-top": "30px"
    },
    attrs: {
      "type": "button",
      "disabled": _vm.selectedPickups.length == 0 ? true : false
    },
    on: {
      "click": function($event) {
        return _vm.checkPendingForRVP()
      }
    }
  }, [_vm._v("Allocate Pickup")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('b-button', {
    staticClass: "btn btn-success mr-2",
    staticStyle: {
      "margin-top": "30px"
    },
    attrs: {
      "type": "button",
      "disabled": _vm.isAllocationRvp == false
    },
    on: {
      "click": function($event) {
        return _vm.confirmTrip()
      }
    }
  }, [_vm._v("Confirm Trip")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [(_vm.errorRvpAllocation || _vm.successRvpAllocation) ? _c('div', {
    staticClass: "col-md-12"
  }, [(_vm.errorRvpAllocation) ? _c('div', {
    staticClass: "alert alert-danger"
  }, [_vm._v("\n                                 " + _vm._s(_vm.errorRvpAllocation) + "\n                              ")]) : _vm._e(), _vm._v(" "), (_vm.successRvpAllocation) ? _c('div', {
    staticClass: "alert alert-success"
  }, [_vm._v("\n                                 " + _vm._s(_vm.successRvpAllocation) + "\n                              ")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), (_vm.morePendingRVPShipmentsModel) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('fieldset', [_c('legend', [_vm._v("List")]), _vm._v(" "), _c('b-card', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('h5', [_vm._v("Below Shipments are from same customer, Please allocate them to same SR. ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('button', {
    staticClass: "btn btn-success mr-2",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.allocatePickup()
      }
    }
  }, [_vm._v("Continue")]), _vm._v(" "), _c('b-button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.closeMPRVPShipments()
      }
    }
  }, [_vm._v(" Cancel")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoadingASL
    },
    on: {
      "update:active": function($event) {
        _vm.isLoadingASL = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "max-height": "400px",
      "height": "auto",
      "overflow-y": "auto"
    }
  }, [_c('table', {
    staticClass: "b-table table table-bordered"
  }, [_c('thead', {
    staticClass: "thead-default"
  }, [_c('tr', [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sAllMoreShip),
      expression: "sAllMoreShip"
    }],
    attrs: {
      "type": "checkbox",
      "value": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.sAllMoreShip) ? _vm._i(_vm.sAllMoreShip, "") > -1 : (_vm.sAllMoreShip)
    },
    on: {
      "click": _vm.selectAllMoreRVPShipments,
      "change": function($event) {
        var $$a = _vm.sAllMoreShip,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.sAllMoreShip = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.sAllMoreShip = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.sAllMoreShip = $$c
        }
      }
    }
  })])]), _vm._v(" "), _c('th', [_vm._v("Client Name")]), _vm._v(" "), _c('th', [_vm._v("Shipping ID")]), _vm._v(" "), _c('th', [_vm._v("Pick Assign Date")]), _vm._v(" "), _c('th', [_vm._v("First Name")]), _vm._v(" "), _c('th', [_vm._v("Customer Address")]), _vm._v(" "), _c('th', [_vm._v("City")]), _vm._v(" "), _c('th', [_vm._v("Pincode")]), _vm._v(" "), _c('th', [_vm._v("Total Items")]), _vm._v(" "), _c('th', [_vm._v("Future Pickup Date")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.suggestRVPArrayList), function(row, index) {
    return _c('tr', {
      attrs: {
        "id": 'rvpTrMr' + row.ShippingId
      }
    }, [_c('td', {
      staticClass: "text-center",
      attrs: {
        "scope": "row"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selectedPickupsMore),
        expression: "selectedPickupsMore"
      }],
      staticStyle: {
        "font-size": "0.8em"
      },
      attrs: {
        "type": "checkbox",
        "name": 'selectedPickupsMore' + index
      },
      domProps: {
        "value": row.ShippingId,
        "checked": Array.isArray(_vm.selectedPickupsMore) ? _vm._i(_vm.selectedPickupsMore, row.ShippingId) > -1 : (_vm.selectedPickupsMore)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.selectedPickupsMore,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = row.ShippingId,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.selectedPickupsMore = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.selectedPickupsMore = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.selectedPickupsMore = $$c
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.ClientName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.ShippingId))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("moment")(row.AssignDate)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.CustomerFirstName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.CustomerAddress))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.CustomerCity))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.CustomerPinCode))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.TotalItems))]), _vm._v(" "), _c('td'), _vm._v(" "), _c('input', {
      attrs: {
        "type": "hidden",
        "id": 'CIMr' + row.ShippingId
      },
      domProps: {
        "value": row.ClientId
      }
    })])
  }), _vm._v(" "), (_vm.pickupList.length == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "12",
      "align": "center"
    }
  }, [_vm._v("No record found")])]) : _vm._e()], 2)])])], 1)])])], 1)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoadingASL
    },
    on: {
      "update:active": function($event) {
        _vm.isLoadingASL = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    class: {
      row: true, rvpContHidden: _vm.isActiveRvp
    },
    staticStyle: {
      "max-height": "400px",
      "height": "auto",
      "overflow-y": "auto"
    }
  }, [_c('table', {
    staticClass: "b-table table table-bordered"
  }, [_c('thead', {
    staticClass: "thead-default"
  }, [_c('tr', [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sAll),
      expression: "sAll"
    }],
    attrs: {
      "type": "checkbox",
      "value": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.sAll) ? _vm._i(_vm.sAll, "") > -1 : (_vm.sAll)
    },
    on: {
      "click": _vm.selectAll,
      "change": function($event) {
        var $$a = _vm.sAll,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.sAll = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.sAll = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.sAll = $$c
        }
      }
    }
  })])]), _vm._v(" "), _c('th', [_vm._v("Client Name")]), _vm._v(" "), _c('th', [_vm._v("Shipping ID")]), _vm._v(" "), _c('th', [_vm._v("Pick Assign Date")]), _vm._v(" "), _c('th', [_vm._v("First Name")]), _vm._v(" "), _c('th', [_vm._v("Customer Address")]), _vm._v(" "), _c('th', [_vm._v("City")]), _vm._v(" "), _c('th', [_vm._v("Pincode")]), _vm._v(" "), _c('th', [_vm._v("Total Items")]), _vm._v(" "), _c('th', [_vm._v("Future Pickup Date")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.pickupList), function(row, index) {
    return _c('tr', {
      attrs: {
        "id": 'rvpTr' + row.ShippingId
      }
    }, [_c('td', {
      staticClass: "text-center",
      attrs: {
        "scope": "row"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selectedPickups),
        expression: "selectedPickups"
      }],
      staticStyle: {
        "font-size": "0.8em"
      },
      attrs: {
        "type": "checkbox",
        "name": 'selectedPickups' + index
      },
      domProps: {
        "value": row.ShippingId,
        "checked": Array.isArray(_vm.selectedPickups) ? _vm._i(_vm.selectedPickups, row.ShippingId) > -1 : (_vm.selectedPickups)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.selectedPickups,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = row.ShippingId,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.selectedPickups = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.selectedPickups = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.selectedPickups = $$c
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.ClientName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.ShippingId))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("moment")(row.AssignDate)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.CustomerFirstName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.CustomerAddress))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.CustomerCity))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.CustomerPinCode))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.TotalItems))]), _vm._v(" "), _c('td'), _vm._v(" "), _c('input', {
      attrs: {
        "type": "hidden",
        "id": 'CI' + row.ShippingId
      },
      domProps: {
        "value": row.ClientId
      }
    })])
  }), _vm._v(" "), (_vm.pickupList.length == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "12",
      "align": "center"
    }
  }, [_vm._v("No record found")])]) : _vm._e()], 2)])])], 1)])])], 1)])])], 1), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.closeRvpShipmentsModel
    }
  }, [_vm._v("Close")])])])])])], 1)]), _vm._v(" "), _c('fieldset', [_c('div', {
    staticClass: "card-body1"
  }, [_c('legend', [_vm._v("Print Shipment For Delivery")]), _vm._v(" "), _c('b-card', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Select SR")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-user'></i>",
      "right": _vm.srLoader
    }
  }, [_c('b-input-group', [_c('basic-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "options": _vm.srListFlt,
      "selected-option": _vm.srItemObjFlt,
      "name": "SRFlt",
      "placeholder": "Select SR"
    },
    on: {
      "select": _vm.selectSRFlt
    },
    model: {
      value: (_vm.srIdFlt),
      callback: function($$v) {
        _vm.srIdFlt = $$v
      },
      expression: "srIdFlt"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('SRFlt')),
      expression: "errors.has('SRFlt')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('SRFlt')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Delivery Option")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-cog'></i>"
    }
  }, [_c('basic-select', {
    class: {
      'form-control': true
    },
    attrs: {
      "options": _vm.deliveryOptionListPrint,
      "selected-option": _vm.deliveryOptionItemObjPrint,
      "name": "deliveryOptionPrint",
      "placeholder": "Select Delivery Option"
    },
    on: {
      "select": _vm.selectDeliveryOptionPrint
    },
    model: {
      value: (_vm.deliveryOptionPrint),
      callback: function($$v) {
        _vm.deliveryOptionPrint = $$v
      },
      expression: "deliveryOptionPrint"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("From")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-cog'></i>"
    }
  }, [_c('b-input-group', [_c('basic-select', {
    class: {
      'form-control': true
    },
    attrs: {
      "options": _vm.fromListFlt,
      "selected-option": _vm.fromItemObjFlt,
      "name": "from",
      "placeholder": "Select From"
    },
    on: {
      "select": _vm.selectFromFlt
    },
    model: {
      value: (_vm.fromIdFlt),
      callback: function($$v) {
        _vm.fromIdFlt = $$v
      },
      expression: "fromIdFlt"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('from')),
      expression: "errors.has('from')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('from')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('b-button', {
    staticClass: "btn btn-success mr-2",
    attrs: {
      "type": "button",
      "disabled": _vm.srIdFlt == false || _vm.isLoadingPrint == true
    },
    on: {
      "click": function($event) {
        return _vm.printShipmentForDelivery('delivery')
      }
    }
  }, [_vm._v("Print Shipments For Delivery")]), _vm._v(" "), _c('b-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.deliveryOptionPrint == 'RTO' || _vm.deliveryOptionPrint == 'DTO'),
      expression: "deliveryOptionPrint=='RTO' || deliveryOptionPrint=='DTO'"
    }],
    staticClass: "btn btn-success mr-2",
    attrs: {
      "type": "button",
      "disabled": _vm.srIdFlt == false || _vm.isLoadingPrint == true
    },
    on: {
      "click": function($event) {
        return _vm.printShipmentForDelivery('vendor')
      }
    }
  }, [_vm._v("Print Shipments For Vendor")])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "row mt-2",
    attrs: {
      "id": "printShipmentContent"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoadingPrint
    },
    on: {
      "update:active": function($event) {
        _vm.isLoadingPrint = $event
      }
    }
  }), _vm._v(" "), (_vm.srShipmentPrintList.length > 0 && _vm.printDType == 'delivery') ? _c('div', {
    staticClass: "col-lg-12"
  }, [_c('table', {
    staticStyle: {
      "border": "none !important"
    },
    attrs: {
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticStyle: {
      "border": "none !important"
    },
    attrs: {
      "align": "center",
      "width": "20%"
    }
  }, [_c('span', {
    staticClass: "tbl-fs16"
  }, [_vm._v("Delivery Sheet")]), _c('br'), _vm._v(" "), _c('img', {
    attrs: {
      "src": "http://xbdashboard.xpressbees.com/img/logo.png"
    }
  })]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border": "none !important"
    },
    attrs: {
      "width": "80%"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    attrs: {
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "width": "20%",
      "valign": "top"
    }
  }, [_c('span', {
    staticClass: "tbl-fs16"
  }, [_vm._v(_vm._s(_vm.srShipmentPrintList.length > 0 ? _vm.srShipmentPrintList[0].ShipCity : ''))]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "tbl-fs16"
  }, [_vm._v(_vm._s(_vm.currentDate()))]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "tbl-fs12"
  }, [_vm._v("CC PH:"), _c('br'), _vm._v("0204660 8107")])]), _vm._v(" "), _c('td', {
    staticClass: "tbl-fs12",
    attrs: {
      "width": "20%",
      "rowspan": "2",
      "valign": "top"
    }
  }, [_c('span', [_c('b', [_vm._v("Log Time")])]), _c('hr'), _vm._v(" "), _c('span', [_vm._v("Start: ")]), _c('hr'), _vm._v(" "), _c('span', [_vm._v("End: ")])]), _vm._v(" "), _c('td', {
    staticClass: "tbl-fs16",
    attrs: {
      "width": "20%",
      "valign": "top"
    }
  }, [_c('span', [_vm._v("COD Amt: "), _c('br'), _vm._v("Rs. " + _vm._s(_vm.totalCODAmount))])]), _vm._v(" "), _c('td', {
    staticClass: "tbl-fs16",
    attrs: {
      "width": "20%",
      "valign": "top"
    }
  }, [_c('span', [_vm._v("Total Shipments : " + _vm._s(_vm.srShipmentPrintList.length))])]), _vm._v(" "), _c('td', {
    staticClass: "tbl-fs12",
    attrs: {
      "width": "20%",
      "valign": "top"
    }
  }, [_c('span', [_vm._v("Print By:")]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.createdBy))]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.printShipDateTime()))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', [_c('b', [_vm._v("SR Details (EmpCode)")])])]), _vm._v(" "), _c('td', [_c('span', [_vm._v("Collected: ")])]), _vm._v(" "), _c('td', [_c('span', [_vm._v("Delivered: ")])]), _vm._v(" "), _c('td', {
    attrs: {
      "rowspan": "2",
      "valign": "top"
    }
  }, [_c('span', [_vm._v("Verified By:")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tbl-fs12"
  }, [_c('span', [_vm._v(_vm._s(_vm.srNameShipPrint))]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.srPhoneShipPrint))])]), _vm._v(" "), _c('td', {
    staticClass: "tbl-fs12"
  }, [_c('span', [_c('b', [_vm._v("Log Meter")])]), _c('br'), _vm._v(" "), _c('span', [_vm._v("Start: ")])]), _vm._v(" "), _c('td', [_c('span', [_vm._v("End: ")])]), _vm._v(" "), _c('td', [_c('span', [_vm._v("RTO: ")])])])])])])])])]), _vm._v(" "), _c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    attrs: {
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "width": "5%"
    }
  }, [_c('span', [_c('strong', [_vm._v("SR.No")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "25%"
    }
  }, [_c('span', [_c('strong', [_vm._v("ShippingId")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "35%"
    }
  }, [_c('span', [_c('strong', [_vm._v("Consignee Name and Address")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "35%"
    }
  }, [_c('span', [_c('strong', [_vm._v("Fill Details")])])])]), _vm._v(" "), _vm._l((_vm.srShipmentPrintList), function(each, index) {
    return _c('tr', {
      attrs: {
        "height": "100px",
        "valign": "top"
      }
    }, [_c('td', {
      attrs: {
        "align": "center"
      }
    }, [_c('span', [_vm._v(_vm._s(index + 1))])]), _vm._v(" "), _c('td', {
      attrs: {
        "align": "center"
      }
    }, [_c('div', [_c('barcode', {
      attrs: {
        "height": "50",
        "fontSize": "16",
        "value": each.ShippingID
      }
    }, [_vm._v("\n                            " + _vm._s(each.ShippingID) + "\n                          ")])], 1), _vm._v(" "), _c('span', {
      staticClass: "tbl-fs16"
    }, [_vm._v(_vm._s(each.OrderType))]), (each.OrderType == 'COD') ? _c('span', {
      staticClass: "tbl-fs16"
    }, [_vm._v(" (Rs. " + _vm._s(each.NetPayment) + ") ")]) : _vm._e()]), _vm._v(" "), _c('td', [_c('span', {
      staticClass: "tbl-fs16"
    }, [_vm._v("Assign Batch No :- " + _vm._s(each.AssignBatchNo))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(each.ShipName))]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(each.ShipAddress))]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(each.ShipCity) + "    " + _vm._s(each.ShipPincode))]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(each.ShipState) + "   ")])]), _vm._v(" "), _c('td', [_c('table', {
      staticClass: "table-bordered table-hover tbl datatables",
      attrs: {
        "width": "100%",
        "height": "113px"
      }
    }, [_c('tbody', [_c('tr', [_c('td', {
      attrs: {
        "colspan": "3"
      }
    }, [_c('span', [_vm._v("Receiver Signature:")]), _c('br'), _c('br'), _vm._v(" "), _c('span', {
      staticStyle: {
        "float": "right"
      }
    }, [_vm._v("Name")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', [_vm._v("Ph:")])]), _vm._v(" "), _c('td', [_c('span', [_vm._v("Time:")])]), _vm._v(" "), _c('td', [_c('span', [_vm._v("Meter:")])])])])])])])
  })], 2)])]) : _vm._e(), _vm._v(" "), (_vm.srShipmentPrintList.length > 0 && _vm.printDType == 'vendor') ? _c('div', {
    staticClass: "col-lg-12"
  }, [_c('table', {
    staticStyle: {
      "border": "none !important"
    },
    attrs: {
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticStyle: {
      "border": "none !important"
    },
    attrs: {
      "align": "center",
      "width": "30%"
    }
  }, [_c('h1', [_vm._v(_vm._s(_vm.rtoDtoDrsTitle))])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border": "none !important"
    },
    attrs: {
      "width": "70%"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    attrs: {
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "tbl-fs16",
    attrs: {
      "width": "20%",
      "valign": "top"
    }
  }, [_vm._v("\n                                Date: " + _vm._s(_vm.currentDate()) + "\n                              ")]), _vm._v(" "), _c('td', {
    staticClass: "tbl-fs16",
    attrs: {
      "width": "20%",
      "valign": "top"
    }
  }, [_vm._v("\n                                Time: " + _vm._s(_vm.currentTime()) + "\n                              ")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "center"
    }
  }, [_c('barcode', {
    attrs: {
      "height": "50",
      "fontSize": "16",
      "value": _vm.rtoDRSBatchId
    }
  })], 1), _vm._v(" "), _c('td', {
    staticClass: "tbl-fs16"
  }, [_c('p', [_c('b', [_vm._v("BatchId: " + _vm._s(_vm.rtoDRSBatchId))])]), _vm._v(" "), _c('span', [_c('b', [_vm._v("Client Name: " + _vm._s(_vm.rtoDRSClientName) + " "), _c('br'), _vm._v("\n                                Vendor Name: " + _vm._s(_vm.rtoDRSVendorName))])])])])])])])])])]), _vm._v(" "), _c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    attrs: {
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "tbl-fs16nb",
    attrs: {
      "width": "5%",
      "align": "center"
    }
  }, [_vm._v("SR.No")]), _vm._v(" "), _c('td', {
    staticClass: "tbl-fs16nb",
    attrs: {
      "width": "15%",
      "align": "center"
    }
  }, [_vm._v("DRS.No")]), _vm._v(" "), _c('td', {
    staticClass: "tbl-fs16nb",
    attrs: {
      "width": "20%",
      "align": "center"
    }
  }, [_vm._v("ShippingId")]), _vm._v(" "), _c('td', {
    staticClass: "tbl-fs16nb",
    attrs: {
      "width": "20%",
      "align": "center"
    }
  }, [_vm._v("POID")]), _vm._v(" "), _c('td', {
    staticClass: "tbl-fs16nb",
    attrs: {
      "width": "40%",
      "align": "center"
    }
  }, [_vm._v("Remarks")])]), _vm._v(" "), _vm._l((_vm.srShipmentPrintList), function(each, index) {
    return _c('tr', {
      attrs: {
        "valign": "top"
      }
    }, [_c('td', {
      staticClass: "tbl-fs16nb",
      attrs: {
        "align": "center"
      }
    }, [_c('span', [_vm._v(_vm._s(index + 1))])]), _vm._v(" "), _c('td', {
      staticClass: "tbl-fs16nb",
      attrs: {
        "align": "center"
      }
    }, [_vm._v(_vm._s(each.SrNo))]), _vm._v(" "), _c('td', {
      staticClass: "tbl-fs16nb"
    }, [_vm._v(_vm._s(each.ShippingID))]), _vm._v(" "), _c('td', {
      staticClass: "tbl-fs16nb"
    }, [_vm._v(_vm._s(each.OrderNo))]), _vm._v(" "), _c('td')])
  })], 2)]), _vm._v(" "), _c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    attrs: {
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "tbl-fs16",
    attrs: {
      "height": "100",
      "width": "40%",
      "valign": "top"
    }
  }, [_c('p', [_vm._v("SR Responsible for WAREHOUSE Handover")]), _vm._v(" "), _c('p', [_vm._v("Name : " + _vm._s(_vm.rtoDRSWHHandOverPersonName))]), _vm._v(" "), _c('p', [_vm._v("Signature :")])]), _vm._v(" "), _c('td', {
    staticClass: "tbl-fs16",
    attrs: {
      "height": "100",
      "width": "30%",
      "valign": "top"
    }
  }, [_vm._v("\n                        Customer Signature & Seal :\n                      ")]), _vm._v(" "), _c('td', {
    staticClass: "tbl-fs16",
    attrs: {
      "height": "100",
      "width": "30%",
      "valign": "top"
    }
  }, [_c('p', [_vm._v("Date :")]), _vm._v(" "), _c('p', [_vm._v("Time :")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tbl-fs16",
    attrs: {
      "colspan": "3",
      "height": "100",
      "width": "40%",
      "valign": "top"
    }
  }, [_c('p', [_vm._v("POD UPLOAD DONE BY :")]), _vm._v(" "), _c('p', [_vm._v("Name :")]), _vm._v(" "), _c('p', [_vm._v("Signature :")])])])])])]) : _vm._e(), _vm._v(" "), (_vm.srShipmentPrintList.length > 0 && _vm.printDType == 'printRTORunsheet') ? _c('div', {
    staticClass: "col-lg-12"
  }, [_c('table', {
    staticStyle: {
      "border": "none !important"
    },
    attrs: {
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticStyle: {
      "border": "none !important"
    },
    attrs: {
      "align": "center",
      "width": "20%"
    }
  }, [_c('span', {
    staticClass: "tbl-fs16"
  }, [_vm._v(_vm._s(_vm.rtoDtoSheetTitle))]), _c('br'), _vm._v(" "), _c('img', {
    attrs: {
      "src": "http://xbdashboard.xpressbees.com/img/logo.png"
    }
  })]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border": "none !important"
    },
    attrs: {
      "width": "80%"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    attrs: {
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "width": "20%",
      "valign": "top"
    }
  }, [_c('span', {
    staticClass: "tbl-fs16"
  }, [_vm._v(_vm._s(_vm.rtoRunSTHubName))]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "tbl-fs16"
  }, [_vm._v(_vm._s(_vm.currentDate()))])]), _vm._v(" "), _c('td', {
    staticClass: "tbl-fs12",
    attrs: {
      "width": "15%",
      "rowspan": "2",
      "valign": "top"
    }
  }, [_c('span', [_c('b', [_vm._v("Log Time")])]), _c('hr'), _vm._v(" "), _c('span', [_vm._v("Start: ")]), _c('hr'), _vm._v(" "), _c('span', [_vm._v("End: ")])]), _vm._v(" "), _c('td', {
    staticClass: "tbl-fs16",
    attrs: {
      "width": "30%",
      "valign": "top"
    }
  }, [_c('span', [_vm._v("COD Amount: "), _c('br'), _vm._v("Rs. " + _vm._s(_vm.totalCODAmount))]), _c('br'), _vm._v(" "), _c('span', [_vm._v("DRS No: "), _c('br'), _vm._v(" " + _vm._s(_vm.rtoRunSTDrsNo))])]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "15%",
      "valign": "top"
    }
  }, [_c('b', [_vm._v("Total Shipments : " + _vm._s(_vm.srShipmentPrintList.length))])]), _vm._v(" "), _c('td', {
    staticClass: "tbl-fs12",
    attrs: {
      "width": "20%",
      "valign": "top"
    }
  }, [_c('span', [_vm._v("Print By:")]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.createdBy))]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.printShipDateTime()))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', [_c('b', [_vm._v("SR Details (EmpCode)")])])]), _vm._v(" "), _c('td', [_c('span', [_vm._v("Collected: ")])]), _vm._v(" "), _c('td', [_c('span', [_vm._v("Delivered: ")])]), _vm._v(" "), _c('td', {
    attrs: {
      "rowspan": "2",
      "valign": "top"
    }
  }, [_c('span', [_vm._v("Verified By:")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tbl-fs12"
  }, [_c('span', [_vm._v(_vm._s(_vm.srNameShipPrint))]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.srPhoneShipPrint))])]), _vm._v(" "), _c('td', {
    staticClass: "tbl-fs12"
  }, [_c('span', [_c('b', [_vm._v("Log Meter")])]), _c('br'), _vm._v(" "), _c('span', [_vm._v("Start: ")])]), _vm._v(" "), _c('td', [_c('span', [_vm._v("End: ")])]), _vm._v(" "), _c('td', [_c('span', [_vm._v("RTO: ")])])])])])])])])]), _vm._v(" "), _c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    attrs: {
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "width": "5%"
    }
  }, [_c('span', [_c('strong', [_vm._v("SR.No")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "25%"
    }
  }, [_c('span', [_c('strong', [_vm._v("ShippingId")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "35%"
    }
  }, [_c('span', [_c('strong', [_vm._v("Consignee Name and Address")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "35%"
    }
  }, [_c('span', [_c('strong', [_vm._v("Fill Details")])])])]), _vm._v(" "), _vm._l((_vm.srShipmentPrintList), function(each, index) {
    return _c('tr', {
      attrs: {
        "height": "100px",
        "valign": "top"
      }
    }, [_c('td', {
      attrs: {
        "align": "center"
      }
    }, [_c('span', [_vm._v(_vm._s(index + 1))])]), _vm._v(" "), _c('td', {
      attrs: {
        "align": "center"
      }
    }, [_c('div', [_c('barcode', {
      attrs: {
        "height": "50",
        "fontSize": "16",
        "value": each.ShippingID
      }
    }, [_vm._v("\n                            " + _vm._s(each.ShippingID) + "\n                          ")])], 1), _vm._v(" "), _c('span', {
      staticClass: "tbl-fs16"
    }, [_vm._v(_vm._s(each.OrderType))]), (each.OrderType == 'COD') ? _c('span', {
      staticClass: "tbl-fs16"
    }, [_vm._v(" (Rs. " + _vm._s(each.NetPayment) + ") ")]) : _vm._e()]), _vm._v(" "), _c('td', [_c('span', {
      staticClass: "tbl-fs16"
    }, [_vm._v("POID : " + _vm._s(each.OrderNo))]), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "tbl-fs16"
    }, [_vm._v("Assign Batch No : " + _vm._s(each.AssignBatchNo))]), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "tbl-fs16"
    }, [_vm._v("Merchent Name : " + _vm._s(each.SellerName))]), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "tbl-fs16"
    }, [_vm._v("client Name : " + _vm._s(each.ClientName))]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(each.RTOName))]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(each.RTOAddress))]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(each.RTOCity) + " " + _vm._s(each.RTOState) + "    " + _vm._s(each.RTOPincode))]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(each.RTOState) + "   Ph No.: " + _vm._s(each.RTOMobileNo))])]), _vm._v(" "), _c('td', [_c('table', {
      staticClass: "table-bordered table-hover tbl datatables",
      attrs: {
        "width": "100%",
        "height": "113px"
      }
    }, [_c('tbody', [_c('tr', [_c('td', {
      attrs: {
        "colspan": "3"
      }
    }, [_c('span', [_vm._v("Receiver Signature:")]), _c('br'), _c('br'), _vm._v(" "), _c('span', {
      staticStyle: {
        "float": "right"
      }
    }, [_vm._v("Name")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', [_vm._v("Ph:")])]), _vm._v(" "), _c('td', [_c('span', [_vm._v("Time:")])]), _vm._v(" "), _c('td', [_c('span', [_vm._v("Meter:")])])])])])])])
  })], 2)])]) : _vm._e(), _vm._v(" "), (_vm.srShipmentPrintList.length > 0 && _vm.printDType == 'printRVP') ? _c('div', {
    staticClass: "col-lg-12"
  }, [_vm._l((_vm.srShipmentPrintList), function(each, index) {
    return [_c('table', {
      staticStyle: {
        "border": "none !important"
      },
      attrs: {
        "width": "100%"
      }
    }, [_c('tbody', [_c('tr', [_c('td', {
      staticStyle: {
        "border": "none !important"
      },
      attrs: {
        "align": "left"
      }
    }, [_c('img', {
      attrs: {
        "src": "http://xbdashboard.xpressbees.com/img/logo.png"
      }
    })])]), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "border": "none !important"
      },
      attrs: {
        "align": "center"
      }
    }, [_c('h3', [_c('u', [_vm._v("Return Shipment")])])])])])]), _vm._v(" "), _c('table', {
      staticClass: "table-bordered table-hover tbl datatables",
      attrs: {
        "width": "100%"
      }
    }, [_c('tbody', [_c('tr', [_c('td', {
      attrs: {
        "align": "center",
        "width": "40%"
      }
    }, [_c('span', {
      staticClass: "tbl-fs16"
    }, [_vm._v("POID : "), _c('b', [_vm._v(_vm._s(each.OrderNo))])]), _vm._v(" "), _c('barcode', {
      attrs: {
        "height": "50",
        "fontSize": "16",
        "value": each.OrderNo
      }
    })], 1), _vm._v(" "), _c('td', {
      attrs: {
        "align": "center",
        "width": "60%"
      }
    }, [_c('span', {
      staticClass: "tbl-fs16"
    }, [_vm._v("AWB No : "), _c('b', [_vm._v(_vm._s(each.ShippingID))])]), _vm._v(" "), _c('barcode', {
      attrs: {
        "height": "50",
        "fontSize": "16",
        "value": each.ShippingID
      }
    })], 1)]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
      staticClass: "tbl-fs16"
    }, [_vm._v("Customer Name and Address ")])]), _vm._v(" "), _c('td', [_c('span', {
      staticClass: "tbl-fs16"
    }, [_vm._v("Return to Client Name : " + _vm._s(each.ClientName) + "      IS QC : " + _vm._s(each.IsQC))])])]), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "tbl-fs16nb",
      attrs: {
        "valign": "top"
      }
    }, [_c('span', [_vm._v(_vm._s(each.ShipName) + " ")]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(each.ShipAddress) + " ")]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(each.ShipCity) + " " + _vm._s(each.ShipPincode) + " ")]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(each.ShipState) + " ")])]), _vm._v(" "), _c('td', {
      attrs: {
        "valign": "top"
      }
    }, [_c('span', {
      staticClass: "tbl-fs16"
    }, [_vm._v(_vm._s(each.RTOAddress) + " " + _vm._s(each.RTOCity) + " " + _vm._s(each.RTOState) + " " + _vm._s(each.RTOPincode))]), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "tbl-fs16"
    }, [_vm._v(_vm._s(each.RTOCity) + " " + _vm._s(each.RTOPincode))]), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "tbl-fs16"
    }, [_vm._v(_vm._s(each.RTOState))]), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "tbl-fs16"
    }, [_vm._v("Phone No. : " + _vm._s(each.RTOMobileNo))]), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "tbl-fs16"
    }, [_vm._v("Destination Hub : " + _vm._s(each.HubName))])])])])]), _vm._v(" "), _c('table', {
      staticStyle: {
        "border": "none !important"
      },
      attrs: {
        "width": "100%"
      }
    }, [_c('tbody', [_c('tr', [_c('td', {
      staticStyle: {
        "border": "none !important"
      },
      attrs: {
        "colspan": "2"
      }
    }, [_c('span', {
      staticClass: "tbl-fs16nb"
    }, [_vm._v("Pick-Up Location : "), _c('b', [_vm._v(_vm._s(each.OriginHub))])])])]), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "border": "none !important"
      },
      attrs: {
        "colspan": "2"
      }
    }, [_c('span', {
      staticClass: "tbl-fs16nb"
    }, [_vm._v("- - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - Tear Here - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -")])])])])]), _vm._v(" "), _c('table', {
      staticClass: "table-bordered table-hover tbl datatables",
      attrs: {
        "width": "100%"
      }
    }, [_c('tbody', [_c('tr', [_c('td', {
      attrs: {
        "colspan": "2",
        "width": "100%"
      }
    }, [_c('span', {
      staticClass: "tbl-fs16"
    }, [_vm._v("REVERSE PICK-UP DISPATCH SLIP")])])]), _vm._v(" "), _c('tr', [_c('td', {
      attrs: {
        "align": "center",
        "width": "40%"
      }
    }, [_c('span', {
      staticClass: "tbl-fs16"
    }, [_vm._v("POID : "), _c('b', [_vm._v(_vm._s(each.OrderNo))])]), _vm._v(" "), _c('barcode', {
      attrs: {
        "height": "50",
        "fontSize": "16",
        "value": each.OrderNo
      }
    })], 1), _vm._v(" "), _c('td', {
      attrs: {
        "align": "center",
        "width": "60%"
      }
    }, [_c('span', {
      staticClass: "tbl-fs16"
    }, [_vm._v("AWB No : "), _c('b', [_vm._v(_vm._s(each.ShippingID))])]), _vm._v(" "), _c('barcode', {
      attrs: {
        "height": "50",
        "fontSize": "16",
        "value": each.ShippingID
      }
    })], 1)]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
      staticClass: "tbl-fs16"
    }, [_vm._v("Customer Name and Address ")])]), _vm._v(" "), _c('td', [_c('span', {
      staticClass: "tbl-fs16"
    }, [_vm._v("Return to Client Name : " + _vm._s(each.ClientName) + "      IS QC : " + _vm._s(each.IsQC))])])]), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "tbl-fs16nb",
      attrs: {
        "valign": "top"
      }
    }, [_c('span', [_vm._v(_vm._s(each.ShipName) + " ")]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(each.ShipAddress) + " ")]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(each.ShipCity) + " " + _vm._s(each.ShipPincode) + " ")]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(each.ShipState) + " ")])]), _vm._v(" "), _c('td', {
      attrs: {
        "valign": "top"
      }
    }, [_c('span', {
      staticClass: "tbl-fs16"
    }, [_vm._v(_vm._s(each.RTOAddress) + " " + _vm._s(each.RTOCity) + " " + _vm._s(each.RTOState) + " " + _vm._s(each.RTOPincode))]), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "tbl-fs16"
    }, [_vm._v(_vm._s(each.RTOCity) + " " + _vm._s(each.RTOPincode))]), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "tbl-fs16"
    }, [_vm._v(_vm._s(each.RTOState))]), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "tbl-fs16"
    }, [_vm._v("Phone No. : " + _vm._s(each.RTOMobileNo))])])]), _vm._v(" "), _c('tr', [_c('td', {
      attrs: {
        "colspan": "2"
      }
    }, [_c('span', {
      staticClass: "tbl-fs16nb"
    }, [_vm._v("Issue Category :")])])])])]), _vm._v(" "), _c('table', {
      staticClass: "table-bordered table-hover tbl datatables",
      attrs: {
        "width": "100%"
      }
    }, [_c('tbody', [_c('tr', [_c('td', {
      attrs: {
        "width": "5%"
      }
    }, [_c('span', [_c('strong', [_vm._v("SR.No")])])]), _vm._v(" "), _c('td', {
      attrs: {
        "width": "15%",
        "align": "center"
      }
    }, [_c('span', [_c('strong', [_vm._v("POID")])])]), _vm._v(" "), _c('td', {
      attrs: {
        "width": "35%",
        "align": "center"
      }
    }, [_c('span', [_c('strong', [_vm._v("Product Name")])])]), _vm._v(" "), _c('td', {
      attrs: {
        "width": "15%",
        "align": "center"
      }
    }, [_c('span', [_c('strong', [_vm._v("Product ID")])])]), _vm._v(" "), _c('td', {
      attrs: {
        "width": "15%",
        "align": "center"
      }
    }, [_c('span', [_c('strong', [_vm._v("Product Qty")])])]), _vm._v(" "), _c('td', {
      attrs: {
        "width": "15%",
        "align": "center"
      }
    }, [_c('span', [_c('strong', [_vm._v("Picked Qty")])])])]), _vm._v(" "), _vm._l((each.productDetails), function(row, index) {
      return _c('tr', {
        attrs: {
          "valign": "top"
        }
      }, [_c('td', {
        attrs: {
          "align": "center"
        }
      }, [_c('span', [_vm._v(_vm._s(index + 1))])]), _vm._v(" "), _c('td', {
        attrs: {
          "align": "center"
        }
      }, [_vm._v(_vm._s(each.OrderNo))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.ProductName))]), _vm._v(" "), _c('td', {
        attrs: {
          "align": "center"
        }
      }, [_vm._v(_vm._s(row.ProductID))]), _vm._v(" "), _c('td', {
        attrs: {
          "align": "right"
        }
      }, [_vm._v(_vm._s(row.ProductQty))]), _vm._v(" "), _c('td')])
    })], 2)]), _vm._v(" "), _c('table', {
      staticStyle: {
        "border": "none !important"
      },
      attrs: {
        "width": "100%"
      }
    }, [_c('tbody', [_c('tr', {
      staticStyle: {
        "border": "none !important"
      }
    }, [_c('td', {
      attrs: {
        "width": "40%"
      }
    }, [_c('span', {
      staticClass: "tbl-fs16nb"
    }, [_vm._v("Pick-Up Location : "), _c('b', [_vm._v(_vm._s(each.OriginHub))])])]), _vm._v(" "), _c('td', {
      attrs: {
        "width": "30%"
      }
    }, [_c('span', {
      staticClass: "tbl-fs16nb"
    }, [_vm._v("Date - Time : ")])]), _vm._v(" "), _c('td', {
      attrs: {
        "width": "30%"
      }
    }, [_c('span', {
      staticClass: "tbl-fs16nb"
    }, [_vm._v("Sign :")])])]), _vm._v(" "), _c('tr', {
      staticStyle: {
        "border": "none !important"
      }
    }, [_c('td', {
      attrs: {
        "width": "40%"
      }
    }, [_c('span', {
      staticClass: "tbl-fs16nb"
    }, [_vm._v("Packed By :")])]), _vm._v(" "), _c('td', {
      attrs: {
        "width": "60%",
        "colspan": "2"
      }
    }, [_c('span', {
      staticClass: "tbl-fs16nb"
    }, [_vm._v("Collected By : " + _vm._s(each.DeliveryUserName))])])]), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "border": "none !important"
      },
      attrs: {
        "colspan": "3"
      }
    }, [_c('span', {
      staticClass: "tbl-fs16nb"
    }, [_vm._v("- - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - Tear Here - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -")])])])])]), _vm._v(" "), _c('table', {
      staticClass: "table-bordered table-hover tbl datatables",
      attrs: {
        "width": "100%"
      }
    }, [_c('tbody', [_c('tr', [_c('td', {
      attrs: {
        "colspan": "2",
        "width": "100%"
      }
    }, [_c('span', {
      staticClass: "tbl-fs16"
    }, [_vm._v("REVERSE PICK-UP ACKNOWLEDGMENT")])])]), _vm._v(" "), _c('tr', [_c('td', {
      attrs: {
        "width": "40%"
      }
    }, [_c('span', {
      staticClass: "tbl-fs16nb"
    }, [_vm._v("POID : "), _c('b', [_vm._v(_vm._s(each.OrderNo))])]), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "tbl-fs16nb"
    }, [_vm._v("AWB No : "), _c('b', [_vm._v(_vm._s(each.ShippingID))])]), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "tbl-fs16nb"
    }, [_vm._v("IS QC : "), _c('b', [_vm._v(_vm._s(each.IsQC))])])]), _vm._v(" "), _c('td', {
      attrs: {
        "align": "right",
        "width": "60%"
      }
    }, [_c('img', {
      attrs: {
        "src": "http://xbdashboard.xpressbees.com/img/logo.png"
      }
    })])]), _vm._v(" "), _c('tr', [_c('td', {
      attrs: {
        "colspan": "2"
      }
    }, [_c('span', {
      staticClass: "tbl-fs16"
    }, [_vm._v("Customer Name and Address ")])])]), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "tbl-fs16nb",
      attrs: {
        "valign": "top",
        "colspan": "2"
      }
    }, [_c('span', [_vm._v(_vm._s(each.ShipName) + " ")]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(each.ShipAddress) + " ")]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(each.ShipCity) + " " + _vm._s(each.ShipPincode) + " ")]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(each.ShipState) + " ")])])]), _vm._v(" "), _c('tr', [_c('td', {
      attrs: {
        "colspan": "2"
      }
    }, [_c('span', {
      staticClass: "tbl-fs16nb"
    }, [_vm._v("Issue Category :")])])])])]), _vm._v(" "), _c('table', {
      staticClass: "table-bordered table-hover tbl datatables",
      attrs: {
        "width": "100%"
      }
    }, [_c('tbody', [_c('tr', [_c('td', {
      attrs: {
        "width": "5%"
      }
    }, [_c('span', [_c('strong', [_vm._v("SR.No")])])]), _vm._v(" "), _c('td', {
      attrs: {
        "width": "15%",
        "align": "center"
      }
    }, [_c('span', [_c('strong', [_vm._v("POID")])])]), _vm._v(" "), _c('td', {
      attrs: {
        "width": "35%"
      }
    }, [_c('span', [_c('strong', [_vm._v("Product Name")])])]), _vm._v(" "), _c('td', {
      attrs: {
        "width": "15%",
        "align": "center"
      }
    }, [_c('span', [_c('strong', [_vm._v("Product ID")])])]), _vm._v(" "), _c('td', {
      attrs: {
        "width": "15%",
        "align": "center"
      }
    }, [_c('span', [_c('strong', [_vm._v("Product Qty")])])]), _vm._v(" "), _c('td', {
      attrs: {
        "width": "15%",
        "align": "center"
      }
    }, [_c('span', [_c('strong', [_vm._v("Picked Qty")])])])]), _vm._v(" "), _vm._l((each.productDetails), function(row, index) {
      return _c('tr', {
        attrs: {
          "valign": "top"
        }
      }, [_c('td', {
        attrs: {
          "align": "center"
        }
      }, [_c('span', [_vm._v(_vm._s(index + 1))])]), _vm._v(" "), _c('td', {
        attrs: {
          "align": "center"
        }
      }, [_vm._v(_vm._s(each.OrderNo))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.ProductName))]), _vm._v(" "), _c('td', {
        attrs: {
          "align": "center"
        }
      }, [_vm._v(_vm._s(row.ProductID))]), _vm._v(" "), _c('td', {
        attrs: {
          "align": "right"
        }
      }, [_vm._v(_vm._s(row.ProductQty))]), _vm._v(" "), _c('td')])
    })], 2)]), _vm._v(" "), _c('table', {
      staticStyle: {
        "border": "none !important"
      },
      attrs: {
        "width": "100%"
      }
    }, [_c('tbody', [_c('tr', {
      staticStyle: {
        "border": "none !important"
      }
    }, [_c('td', {
      attrs: {
        "width": "40%"
      }
    }, [_c('span', {
      staticClass: "tbl-fs16nb"
    }, [_vm._v("Collected By : "), _c('b', [_vm._v(_vm._s(each.DeliveryUserName))])])]), _vm._v(" "), _c('td', {
      attrs: {
        "width": "30%"
      }
    }, [_c('span', {
      staticClass: "tbl-fs16nb"
    }, [_vm._v("Date - Time : ")])]), _vm._v(" "), _c('td', {
      attrs: {
        "width": "30%"
      }
    }, [_c('span', {
      staticClass: "tbl-fs16nb"
    }, [_vm._v("Total : ")])])]), _vm._v(" "), _c('tr', {
      staticStyle: {
        "border": "none !important"
      }
    }, [_c('td', [_c('span', {
      staticClass: "tbl-fs16nb"
    }, [_vm._v(_vm._s(each.SRMobileNo))])]), _vm._v(" "), _c('td', {
      attrs: {
        "colspan": "2"
      }
    }, [_c('span', {
      staticClass: "tbl-fs16nb"
    }, [_vm._v("Sign :")])])])])]), _vm._v(" "), (index != (_vm.srShipmentPrintList.length - 1)) ? _c('div', {
      staticClass: "pagebreak"
    }) : _vm._e()]
  })], 2) : _vm._e()], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.srShipmentPrintList.length > 0),
      expression: "srShipmentPrintList.length>0"
    }],
    staticClass: "col-md-12 mt-2"
  }, [_c('b-button', {
    staticClass: "btn btn-success mr-2",
    attrs: {
      "type": "button",
      "disabled": _vm.isLoadingPrint
    },
    on: {
      "click": function($event) {
        return _vm.printShipments()
      }
    }
  }, [_vm._v("Confirm Print")])], 1)])], 1)])])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6be1ce91","hasScoped":true}!./src/views/components/Allocation/Allocation.html
// module id = 1014
// module chunks = 2